import {notify} from '../utils';

export default {
    methods: {
        notify
    }
};
